<div class="side-nav-wrapper" [class.expanded]="isExpanded">
  <lib-sidenavbar class="micro-slimnav-container" [class.is-expanded]="isExpanded" [theme]="'light'"
    [sidenavbarstyle]="getSidebarStyle()" [CollpaseBtnStyle]="getCollapseBtnStyle()"
    (toggleSidebarEvent)="toggleSidebar()">
    <div company-logo class="brand" (click)="goToMap()">
      <img src="/assets/common_icons/vectormarine.svg" class="company-logo-img" />
      <span class="brand-name" *ngIf="isExpanded">VectorMarine</span>
    </div>

    <!-- COLLAPSE / EXPAND TOGGLE (hidden while any page/overlay is open) -->
    <img middle-collapsible-btn *ngIf="!anyOverlayOpen" class="collapse-toggle-icon"
      [ngClass]="{ 'rotate-normal': isExpanded, 'rotate-flipped': !isExpanded }"
      src="https://storybook.predigle.com/assets/Collapse_btn.svg" alt="Toggle sidebar" />

    <!-- TOP ICON NAV -->
    <div navigation-list class="custom-nav-list" [class.expanded]="isExpanded">
      <div class="nav-item" *ngFor="let item of firstNavItems" [appTourAnchor]="anchorForItem(item)"
        (click)="!item.isDisabed && handleNavClick(item)"
        [class.active]="activeItem === item.label" [class.disabled]="item.isDisabed" [class.expanded]="isExpanded"
        (mouseenter)="!isExpanded && showTooltip($event, item.label)" (mouseleave)="hideTooltip()">
        <img [src]="item.icon" class="nav-icon" />
        <span class="nav-label" *ngIf="isExpanded">{{ item.label }}</span>

        <span
          *ngIf="item.label === 'Layers' && (submenuService.overlayLoading$ | async)"
          class="overlay-spinner"
          aria-label="Loading overlay">
        </span>
      </div>
    </div>

    <div down-navigation-list class="custom-nav-list" [class.expanded]="isExpanded">
      <div class="nav-item" *ngFor="let item of downNavItems" [appTourAnchor]="anchorForItem(item)"
        (click)="!item.isDisabed && handleNavClick(item)"
        [class.active]="activeItem === item.label" [class.disabled]="item.isDisabed" [class.expanded]="isExpanded"
        (mouseenter)="!isExpanded && showTooltip($event, item.label)" (mouseleave)="hideTooltip()">
        <img [src]="item.icon" class="nav-icon" />
        <span class="nav-label" *ngIf="isExpanded">{{ item.label }}</span>
      </div>
    </div>
  </lib-sidenavbar>
</div>

<!-- Floating tooltip appended to body so no ancestor's overflow / transform / z-index can clip or bury it -->
<div #tooltipRef class="nav-tooltip" *ngIf="hoveredLabel" [style.top.px]="tooltipTop" [style.left.px]="tooltipLeft">
  {{ hoveredLabel }}
</div>

<!-- MOBILE BOTTOM NAV BAR -->
<nav class="bottom-nav">
  <div class="bottom-nav-item" *ngFor="let item of firstNavItems" [appTourAnchor]="anchorForItem(item)"
    (click)="!item.isDisabed && handleNavClick(item)"
    [class.active]="activeItem === item.label" [class.disabled]="item.isDisabed">
    <span class="bottom-nav-icon-wrap">
      <img [src]="item.icon" class="bottom-nav-icon" />
      <span
        *ngIf="item.label === 'Layers' && (submenuService.overlayLoading$ | async)"
        class="overlay-spinner overlay-spinner--bottom"
        aria-label="Loading overlay">
      </span>
    </span>
    <span class="bottom-nav-label">{{ item.label }}</span>
  </div>
  <!-- Network + Profile, the two panel surfaces -->
  <div class="bottom-nav-item" *ngFor="let item of downNavItems.slice(0, 2)" (click)="handleNavClick(item)"
    [class.active]="activeItem === item.label">
    <img [src]="item.icon" class="bottom-nav-icon" />
    <span class="bottom-nav-label">{{ item.label }}</span>
  </div>
</nav>

<app-map-filter></app-map-filter>
<app-map-layers></app-map-layers>
<app-waypoint [mapCenter]="mapCenter"></app-waypoint>
<app-user-profile></app-user-profile>